import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Select } from '~/components/Select'
import Utils from '~/lib/Utils'
import { getCrTeamTaskStepLabels } from '~/services/api/api.settings'

interface SelectStepLabelOption {
  value: string | number
  label: string
  [key: string]: any
}

interface SelectStepLabelValue {
  id?: string | number
  [key: string]: any
}

import type { ActionMeta, SingleValue as SingleValueType, MultiValue } from 'react-select'

interface SelectStepLabelProps {
  name?: string
  value?: SelectStepLabelValue | null
  onChange?: (
    option: SingleValueType<SelectStepLabelOption> | MultiValue<SelectStepLabelOption>,
    actionMeta: ActionMeta<SelectStepLabelOption>
  ) => void
  isDisabled?: boolean
}

function SelectStepLabel(props: SelectStepLabelProps) {
  const [value, setValue] = useState<string | number | null>(null)
  const [crStepLabels, setCrStepLabels] = useState<SelectStepLabelOption[]>([])

  const { t: translate } = useTranslation()

  useEffect(() => {
    if (props.value !== value && crStepLabels.length) {
      if (props.value && props.value.id !== undefined) {
        const initialValue = _.find(crStepLabels, {
          value: props.value.id
        })

        if (initialValue) {
          setValue(initialValue.value)
        }
      }
    }
  }, [props.value, crStepLabels, value])

  useEffect(() => {
    getCrTeamTaskStepLabels().then((data: any) => {
      setCrStepLabels(Utils.transformToSelectOptions(data.elements, 'id', 'text'))
    })
  }, [])

  return (
    <Select
      name={props.name}
      value={value}
      options={crStepLabels}
      placeholder={translate('SELECT_CR_TASK_LABEL_PLACEHOLDER')}
      onChange={props.onChange}
      showNewOptionAtTop={true}
      searchable
      id="85a3a33b-bdaf-44a0-9a83-2352084d39e9"
      isDisabled={props.isDisabled}
    />
  )
}

export default SelectStepLabel
